import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";

export const defaultTemplate = createSubtemplate<SectionKey>({
  name: "default",
  trigger: () => true, // Always matches as fallback
  showProd: true,
  config: {
    sections: [
      "headerImage",
      "sectionBar",
      "breadcrumb",
      "companyInfo",
      "jobSharing",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "experienceReports",
      "locationVideo",
      "about",
      "benefits",
      "similarJobs",
      "stickyApplyBar",
      "stickyContact",
      "printView",
    ],
    sectionBarItems: [
      {
        href: "#company",
        label: "sectionBar_company",
        section: "company",
      },
      {
        href: "#job",
        label: "sectionBar_job",
        section: "job",
      },
      {
        href: "#contact",
        label: "sectionBar_contact",
        section: "contact",
      },
      {
        href: "#applicationProcess",
        label: "sectionBar_process",
        section: "applicationProcess",
      },
      {
        href: "#diversity",
        label: "sectionBar_diversity",
        section: "diversity",
      },
      {
        href: "#experienceReports",
        label: "sectionBar_experienceReports",
        section: "experienceReports",
      },
      {
        href: "#about",
        label: "sectionBar_about",
        section: "about",
      },
      {
        href: "#benefits",
        label: "sectionBar_benefits",
        section: "benefits",
      },
      {
        href: "#similarJobs",
        label: "sectionBar_similarJobs",
        section: "similarJobs",
      },
    ],
  },
});
